var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"has-text-weight-bold has-border-b pb-sm is-size-8 is-uppercase"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }